import React from 'react';

import { ALERT } from '@components/alertsPanel/alertMessages';
import {
  alertStatusFilterGroups,
  getAlertStatusFilterId,
  alertStatusFilterOverrides
} from '@components/filters/devicesFilterLib';

import { useAlertNames } from '../../../containers/core/overview/compositions/alertFilters';
import { AlertStatus } from '../../../services/config/alertConstants';

import { FilterFormProps } from './popoverDialog';
import { BaseAlertsFilter } from './baseAlertsFilter';

export const AlertsFilter: React.FC<FilterFormProps> = ({ close }) => {
  const alertNames = useAlertNames();

  const alertTypes = alertStatusFilterGroups.map(group => group.id as AlertStatus);

  const alertConfig = {
    alertTypes,
    alertNames,
    getFilterId: getAlertStatusFilterId,
    getAvailableLevels: (alertType: AlertStatus) =>
      alertStatusFilterOverrides[alertType] || [ALERT.red, ALERT.yellow, ALERT.green]
  };

  return <BaseAlertsFilter close={close} alertConfig={alertConfig} className="alerts-filter--devices" />;
};
